import React, { useCallback, useEffect, useMemo, useState } from 'react'
import noop from 'lodash/noop'
import { ReactFCC } from '@/types/react'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

interface PayItForwardCheckoutState {
  isPayItForwardComplete: boolean
  onComplete: () => void
}

const PayItForwardCheckoutContext = React.createContext<PayItForwardCheckoutState>({
  isPayItForwardComplete: false,
  onComplete: noop,
})

export const PayItForwardCheckoutProvider: ReactFCC = ({ children }) => {
  const [isPayItForwardComplete, setPayItForwardComplete] = useState(false)
  const { query } = useSafeRouter()

  useEffect(() => {
    if (query.order === 'complete') {
      setPayItForwardComplete(true)
    }
  }, [query.order])

  const onComplete = useCallback(() => {
    setPayItForwardComplete(true)
  }, [setPayItForwardComplete])

  const value = useMemo(
    () => ({
      isPayItForwardComplete,
      onComplete,
    }),
    [isPayItForwardComplete, onComplete],
  )

  return <PayItForwardCheckoutContext.Provider value={value}>{children}</PayItForwardCheckoutContext.Provider>
}

export const usePayItForwardState = (): PayItForwardCheckoutState => {
  return React.useContext(PayItForwardCheckoutContext)
}
